import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component, Fragment } from 'react';
import ActivityIndicator from "react-native-web/dist/exports/ActivityIndicator";
import Platform from "react-native-web/dist/exports/Platform";
import View from "react-native-web/dist/exports/View";
import Text from "react-native-web/dist/exports/Text";
import TouchableOpacity from "react-native-web/dist/exports/TouchableOpacity";
import Image from "react-native-web/dist/exports/Image";
import XDate from 'xdate';
import PropTypes from 'prop-types';
import styleConstructor from "./style";
import { weekDayNames } from "../../dateutils";
import { CHANGE_MONTH_LEFT_ARROW, CHANGE_MONTH_RIGHT_ARROW, HEADER_MONTH_NAME } from "../../testIDs";
import _ from 'lodash';
import { jsx as ___EmotionJSX } from "@emotion/core";

var CalendarHeader = function (_Component) {
  _inherits(CalendarHeader, _Component);

  var _super = _createSuper(CalendarHeader);

  function CalendarHeader(props) {
    var _this;

    _classCallCheck(this, CalendarHeader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "addMonth", function () {
      var addMonth = _this.props.addMonth;
      addMonth(1);
    });

    _defineProperty(_assertThisInitialized(_this), "subtractMonth", function () {
      var addMonth = _this.props.addMonth;
      addMonth(-1);
    });

    _defineProperty(_assertThisInitialized(_this), "onPressLeft", function () {
      var _this$props = _this.props,
          onPressArrowLeft = _this$props.onPressArrowLeft,
          month = _this$props.month;

      if (typeof onPressArrowLeft === 'function') {
        return onPressArrowLeft(_this.subtractMonth, month);
      }

      return _this.subtractMonth();
    });

    _defineProperty(_assertThisInitialized(_this), "onPressRight", function () {
      var _this$props2 = _this.props,
          onPressArrowRight = _this$props2.onPressArrowRight,
          month = _this$props2.month;

      if (typeof onPressArrowRight === 'function') {
        return onPressArrowRight(_this.addMonth, month);
      }

      return _this.addMonth();
    });

    _defineProperty(_assertThisInitialized(_this), "renderWeekDays", function (weekDaysNames) {
      var disabledDaysIndexes = _this.props.disabledDaysIndexes;
      return weekDaysNames.map(function (day, idx) {
        var dayStyle = [_this.style.dayHeader];

        if (_.includes(disabledDaysIndexes, idx)) {
          dayStyle.push(_this.style.disabledDayHeader);
        }

        return ___EmotionJSX(Text, {
          allowFontScaling: false,
          key: idx,
          style: dayStyle,
          numberOfLines: 1,
          accessibilityLabel: ''
        }, day);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderHeader", function () {
      var _this$props3 = _this.props,
          renderHeader = _this$props3.renderHeader,
          month = _this$props3.month,
          monthFormat = _this$props3.monthFormat,
          testID = _this$props3.testID;
      var webProps = Platform.OS === 'web' ? {
        'aria-level': _this.props.webAriaLevel
      } : {};

      if (renderHeader) {
        return renderHeader(month);
      }

      return ___EmotionJSX(Fragment, null, ___EmotionJSX(Text, _extends({
        allowFontScaling: false,
        style: _this.style.monthText,
        testID: testID ? HEADER_MONTH_NAME + "-" + testID : HEADER_MONTH_NAME
      }, webProps), month.toString(monthFormat)));
    });

    _defineProperty(_assertThisInitialized(_this), "onAccessibilityAction", function (event) {
      switch (event.nativeEvent.actionName) {
        case 'decrement':
          _this.onPressLeft();

          break;

        case 'increment':
          _this.onPressRight();

          break;

        default:
          break;
      }
    });

    _this.style = styleConstructor(props.theme);
    return _this;
  }

  _createClass(CalendarHeader, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.month.toString('yyyy MM') !== this.props.month.toString('yyyy MM')) {
        return true;
      }

      if (nextProps.showIndicator !== this.props.showIndicator) {
        return true;
      }

      if (nextProps.hideDayNames !== this.props.hideDayNames) {
        return true;
      }

      if (nextProps.firstDay !== this.props.firstDay) {
        return true;
      }

      if (nextProps.weekNumbers !== this.props.weekNumbers) {
        return true;
      }

      if (nextProps.monthFormat !== this.props.monthFormat) {
        return true;
      }

      if (nextProps.renderArrow !== this.props.renderArrow) {
        return true;
      }

      if (nextProps.disableArrowLeft !== this.props.disableArrowLeft) {
        return true;
      }

      if (nextProps.disableArrowRight !== this.props.disableArrowRight) {
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var leftArrow = ___EmotionJSX(View, null);

      var rightArrow = ___EmotionJSX(View, null);

      var weekDaysNames = weekDayNames(this.props.firstDay);
      var testID = this.props.testID;

      if (!this.props.hideArrows) {
        leftArrow = ___EmotionJSX(TouchableOpacity, {
          onPress: this.onPressLeft,
          disabled: this.props.disableArrowLeft,
          style: this.style.arrow,
          hitSlop: {
            left: 20,
            right: 20,
            top: 20,
            bottom: 20
          },
          testID: testID ? CHANGE_MONTH_LEFT_ARROW + "-" + testID : CHANGE_MONTH_LEFT_ARROW
        }, this.props.renderArrow ? this.props.renderArrow('left') : ___EmotionJSX(Image, {
          source: require("../img/previous.png"),
          style: this.props.disableArrowLeft ? this.style.disabledArrowImage : this.style.arrowImage
        }));
        rightArrow = ___EmotionJSX(TouchableOpacity, {
          onPress: this.onPressRight,
          disabled: this.props.disableArrowRight,
          style: this.style.arrow,
          hitSlop: {
            left: 20,
            right: 20,
            top: 20,
            bottom: 20
          },
          testID: testID ? CHANGE_MONTH_RIGHT_ARROW + "-" + testID : CHANGE_MONTH_RIGHT_ARROW
        }, this.props.renderArrow ? this.props.renderArrow('right') : ___EmotionJSX(Image, {
          source: require("../img/next.png"),
          style: this.props.disableArrowRight ? this.style.disabledArrowImage : this.style.arrowImage
        }));
      }

      var indicator;

      if (this.props.showIndicator) {
        indicator = ___EmotionJSX(ActivityIndicator, {
          color: this.props.theme && this.props.theme.indicatorColor
        });
      }

      return ___EmotionJSX(View, {
        testID: testID,
        style: this.props.style,
        accessible: true,
        accessibilityRole: 'adjustable',
        accessibilityActions: [{
          name: 'increment',
          label: 'increment'
        }, {
          name: 'decrement',
          label: 'decrement'
        }],
        onAccessibilityAction: this.onAccessibilityAction,
        accessibilityElementsHidden: this.props.accessibilityElementsHidden,
        importantForAccessibility: this.props.importantForAccessibility
      }, ___EmotionJSX(View, {
        style: this.style.header
      }, leftArrow, ___EmotionJSX(View, {
        style: this.style.headerContainer
      }, this.renderHeader(), indicator), rightArrow), !this.props.hideDayNames && ___EmotionJSX(View, {
        style: this.style.week
      }, this.props.weekNumbers && ___EmotionJSX(Text, {
        allowFontScaling: false,
        style: this.style.dayHeader
      }), this.renderWeekDays(weekDaysNames)));
    }
  }]);

  return CalendarHeader;
}(Component);

_defineProperty(CalendarHeader, "displayName", 'IGNORE');

_defineProperty(CalendarHeader, "propTypes", {
  theme: PropTypes.object,
  hideArrows: PropTypes.bool,
  month: PropTypes.instanceOf(XDate),
  addMonth: PropTypes.func,
  showIndicator: PropTypes.bool,
  firstDay: PropTypes.number,
  renderArrow: PropTypes.func,
  hideDayNames: PropTypes.bool,
  weekNumbers: PropTypes.bool,
  onPressArrowLeft: PropTypes.func,
  onPressArrowRight: PropTypes.func,
  disableArrowLeft: PropTypes.bool,
  disableArrowRight: PropTypes.bool,
  webAriaLevel: PropTypes.number,
  disabledDaysIndexes: PropTypes.arrayOf(PropTypes.number),
  renderHeader: PropTypes.any
});

_defineProperty(CalendarHeader, "defaultProps", {
  monthFormat: 'MMMM yyyy',
  webAriaLevel: 1
});

export default CalendarHeader;

if (typeof CalendarHeader !== 'undefined' && CalendarHeader && CalendarHeader === Object(CalendarHeader) && Object.isExtensible(CalendarHeader) && !CalendarHeader.hasOwnProperty('__filemeta')) {
  Object.defineProperty(CalendarHeader, '__filemeta', {
    configurable: true,
    value: {
      name: "CalendarHeader",
      filename: "node_modules/react-native-calendars/src/calendar/header/index.js"
    }
  });
}